/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { isDev } from '@/helpers';

import { FOMOText, RemoteConfigState } from './types';

export type RemoteConfigResponse = {
  [K in keyof RemoteConfigState]?: RemoteConfigState[K] | string;
} & {
  timeoutGuestUserAfterXMins?: string;
  resetGuestUserTimeoutAfterXHours?: string;
};

const defaultFomoStep: FOMOText = {
  image: '',
  title: '',
  description: '',
  items: [],
  cancelButtonText: '',
  keepButtonText: '',
};

const initialState: RemoteConfigState = {
  fomoTexts: {
    step1: defaultFomoStep,
    step2: defaultFomoStep,
  },
  lastMediaCaptureThresholdForFeaturedHabitatMinutes: 10,
  playerIframeURL: 'https://zoolife.video',
  mediaServerSocketURL: isDev()
    ? 'wss://zoolife.video:5443/Development/websocket'
    : 'wss://zoolife.video:5443/WebRTCAppEE/websocket',
  ambientModeBackgroundMusics: [],
  resetGuestUserTimeoutAfterMs: 24 * 60 * 60_000,
  timeoutGuestUserAfterMs: 5 * 60_000,
};

// TODO: remove frontend type conversion when API is updated
const convertValue = <T>(val?: any) => {
  if (typeof val !== 'string') {
    return val as T;
  }
  try {
    return JSON.parse(val) as T;
  } catch {
    return val as unknown as T;
  }
};

const remoteConfigSlice = createSlice({
  name: 'remoteConfig',
  initialState,
  reducers: {
    setRemoteConfig: (_, { payload }: PayloadAction<RemoteConfigResponse>) => {
      const { timeoutGuestUserAfterXMins, resetGuestUserTimeoutAfterXHours, ...rest } = payload;
      const parsed = Object.fromEntries(
        Object.entries(rest).map(([key, val]) => [key, convertValue(val)]),
      ) as unknown as RemoteConfigState;
      {
        const mins = Number(timeoutGuestUserAfterXMins);
        parsed.timeoutGuestUserAfterMs =
          Number.isFinite(mins) && mins > 0 ? mins * 60_000 : initialState.timeoutGuestUserAfterMs;
      }
      {
        const hours = Number(resetGuestUserTimeoutAfterXHours);
        parsed.resetGuestUserTimeoutAfterMs =
          Number.isFinite(hours) && hours > 0 ? hours * 60 * 60_000 : initialState.resetGuestUserTimeoutAfterMs;
      }
      return parsed;
    },
  },
});

export default remoteConfigSlice;
